import * as Sentry from '@sentry/react';

const SKIP_STATUS_CODES = [401, 403, 409];

export const handleError = (err, file = '', tag = '', tagMessage = '') => {
  if (!err) return;

  try {
    const status = err.response?.status;

    if (SKIP_STATUS_CODES.includes(status)) return;

    if (!err.response || err.code === 'ERR_NETWORK' || err.message?.includes('Network Error')) {
      Sentry.captureMessage(err.message || err.code || 'Network Error', 'info');
      return;
    }

    Sentry.withScope((scope) => {
      scope.setTag('error_file', file || 'unknown');
      scope.setTag('error_type', status >= 500 ? 'server' : 'client');
      if (tag) scope.setTag(tag, tagMessage);
      scope.setExtra('url', err.config?.url);
      scope.setExtra('method', err.config?.method?.toUpperCase());
      scope.setExtra('status', status);
      scope.setExtra('response_data', err.response?.data);
      scope.setFingerprint(['http-error', String(status), err.config?.url || 'unknown']);
      Sentry.captureException(err);
    });
  } catch (_) {
    Sentry.captureException(err);
  }
};

export const handleBreadcrumb = (category = '', message = '', data = {}) => {
  Sentry.addBreadcrumb({
    category,
    message,
    data,
    level: 'info',
  });
};

export function isIgnorableNetworkError(err) {
  if (!err) return false;

  if (err.message?.includes('Network Error')) return true;
  if (err.code === 'ECONNABORTED') return true;
  if (err.response?.status === 0) return true;

  return false;
}
